export const AVAILABLE_LANGS = 
[
    { code: 'en', label: 'English' },
    { code: 'es', label: 'Spanish' },
];

function isAvailableLanguage(lang)
{
    for(let i = 0; i < AVAILABLE_LANGS.length; i++)
    {
        if(AVAILABLE_LANGS[i].code == lang)
        {
            return true;
        }
    }
    return false;
}
export default isAvailableLanguage;
